import { styled } from "@mui/material";
import { styledConstants } from "./styledConstants";

export const StyledErrorDiv = styled("div")(styledConstants.errorLabel);
export const StyledInformationDiv = styled("div")(styledConstants.informationLabel);